import { Reveal } from "@/components/Reveal";
import { AppIcon } from "@/components/Brand";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/brand";

export default function DownloadSection() {
  return (
    <section id="download" data-testid="download-section" className="relative grain bg-[#1E1E1E] text-white py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 techgrid-dark opacity-50" />
      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <Reveal>
          <span className="inline-grid place-items-center w-20 h-20 rounded-[1.4rem] bg-[#2BBFB3]/15 border border-[#2BBFB3]/30">
            <AppIcon size={52} />
          </span>
          <h2 className="mt-7 font-display font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.02]">
            Download DriveAssure.
          </h2>
          <p className="mt-5 max-w-xl mx-auto text-lg text-white/60 leading-relaxed">
            The professional toolkit for driving instructors — GPS lesson tracking, digital records and
            shareable progress reports. Free tier included, no card required.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href={APP_STORE_URL}
              data-testid="app-store-badge"
              aria-label="Download DriveAssure on the App Store"
              className="transition-transform hover:scale-[1.04] active:scale-[0.98]"
            >
              <img src="/badges/app-store.svg" alt="Download on the App Store" className="h-14 w-auto" />
            </a>
            <a
              href={PLAY_STORE_URL}
              data-testid="play-store-badge"
              aria-label="Get DriveAssure on Google Play"
              className="transition-transform hover:scale-[1.04] active:scale-[0.98]"
            >
              <img src="/badges/google-play.png" alt="Get it on Google Play" className="h-14 w-auto" />
            </a>
          </div>
          <p className="mt-6 text-sm text-white/40">Store listings are launching soon.</p>
        </Reveal>
      </div>
    </section>
  );
}
